// extracted by mini-css-extract-plugin
export var typingIndicator = "_pv-0";